import {
	CATEGORIES_SETTINGS_ADD_CATEGORIES
} from "../../constants";

export const AddCategories = (categories) => {
	return {
		type: CATEGORIES_SETTINGS_ADD_CATEGORIES,
		payload: {
			data: {
				categories: categories
			},
		},
	};
};


// WEBPACK FOOTER //
// ./src/api/categories/actions.js